import Button from 'react-bootstrap/Button'

function AboutButton() {
  const handleClick = () => { document.location = "/About" }
  return <Button variant="light" onClick={handleClick}>About ShippersEdge</Button>
}

export default AboutButton
